/*
Slider Documentation: https://swiperjs.com/
*/
import Swiper from "swiper";

// Base styles ====================================================================================

// Modules: =======================================================================================
// Navigation, Pagination, Autoplay, EffectFade, Lazy, Manipulation

import { Navigation, Autoplay } from "swiper/modules";

//=================================================================================================

function initSliders() {
	const sliders = document.querySelectorAll(".swiper");
	if (sliders.length > 0) {
		sliders.forEach((slider) => {
			//    new Swiper(slider, {
			if (slider.classList.contains("related-posts__slider")) return;
			if (slider.classList.contains("swiper-stories")) return;
			if (slider.classList.contains("benefits-swiper")) return;
			if (slider.classList.contains("adv-cards")) return;
			if (slider.classList.contains("teachers__swiper")) return;
			if (slider.classList.contains("price-exp__swiper")) return;
			const isLanding = slider.classList.contains("landing"); // Проверка наличия класса .landing
			const swiperConfig = {
				modules: [Navigation, Autoplay],
				spaceBetween: 26,
				slidesPerView: 3,
				loop: true,
				speed: 800,
				// autoHeight: true,
				autoplay: {
					delay: 3500,
					disableOnInteraction: false,
				},
				navigation: {
					prevEl: slider.querySelector(".navigation__btn_prev"),
					nextEl: slider.querySelector(".navigation__btn_next"),
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 10,
					},
					767.98: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					991.98: {
						slidesPerView: 3,
						spaceBetween: 26,
					},
					...(isLanding && {
						991.98: {
							slidesPerView: 2,
							spaceBetween: 26,
						},
						1200: {
							slidesPerView: 3,
							spaceBetween: 26,
						},
					}),
				},
				on: {
					init() {
						slider.addEventListener("mouseenter", () => {
							this.autoplay.stop();
						});
						slider.addEventListener("mouseleave", () => {
							this.autoplay.start();
						});
					},
				},
			};
			new Swiper(slider, swiperConfig);
		});
	}
}
window.addEventListener("load", function () {
	initSliders();
});
